import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { DaysLeft } from "../../Dashboard/EventList/TaskCard";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { StyledTextarea } from "../../common/Textareas";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { axiosInstance } from "../../../utils/networking";
import { assistances } from "../Interaction";
import { StyledButtonMain } from "../../common/Buttons";

interface BusinessActionPlanCardProps {
  enableEdit: boolean;
  actionPlan: any;
  setActionPlan: (actionPlan: any) => void;
  onEdit?: (actionPlan: any) => void;
}
const timelineSelections = ["30 days", "60 days", "90 days", "On going"];
const actions = ["Direct Consulting", "Resource Referral", "B2B Referral"];
const BusinessActionPlanCard: React.FC<BusinessActionPlanCardProps> = ({
  enableEdit,
  actionPlan,
  setActionPlan,
  onEdit,
}) => {
  const handleResourceSelection = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: actionPlan,
      })
      .then((res) => {
        if (res.status === 200) {
          window.open(`/dashboard/resources?case_id=${actionPlan.case_id}`);
        } else {
          console.log("API Error saving action plan");
        }
      });
  };

  const handleB2BSelection = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: actionPlan,
      })
      .then((res) => {
        if (res.status === 200) {
          window.open(`/dashboard/providers?case_id=${actionPlan.case_id}`);
        } else {
          console.log("API Error saving action plan");
        }
      });
  };

  return (
    <TableContainer component={"table"}>
      {actionPlan.daysLeft && (
        <caption>
          <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
            <AccessAlarmIcon
              sx={{ fontSize: "44px" }}
              color={
                actionPlan.daysLeft < 0
                  ? "error"
                  : actionPlan.daysLeft < 7
                    ? "warning"
                    : "success"
              }
            ></AccessAlarmIcon>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {actionPlan.businessObjective}
              </Typography>
              <DaysLeft action={actionPlan}></DaysLeft>
            </Box>
            <Box></Box>
          </Stack>
        </caption>
      )}

      <TableBody sx={{ display: "table", width: "100%", tableLayout: "fixed" }}>
        <TableRow>
          <TableCell sx={{ width: "240px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker"]}
                sx={{ display: "block", width: "100%" }}
              >
                <DatePicker
                  sx={{ width: "50px" }}
                  label="Action Plan Date"
                  value={dayjs(actionPlan.startDate)}
                  onChange={(value: any) => {
                    setActionPlan({ ...actionPlan, startDate: dayjs(value) });
                  }}
                  readOnly={!enableEdit}
                />
              </DemoContainer>
            </LocalizationProvider>
          </TableCell>
          <TableCell sx={{ width: enableEdit ? "200px" : "240px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-chip-label">Timeline</InputLabel>
              <Select
                disabled={actionPlan.action === "B2B Referral"}
                label="Timeline"
                onChange={(e: any) => {
                  setActionPlan({ ...actionPlan, timeLine: e.target.value });
                }}
                value={
                  actionPlan.action === "B2B Referral"
                    ? "30 days"
                    : actionPlan.timeLine
                }
                readOnly={!enableEdit}
              >
                {timelineSelections.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </TableCell>
          <TableCell sx={{ width: enableEdit ? "200px" : "240px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-chip-label">Action</InputLabel>
              <Select
                label="Action"
                onChange={(e: any) => {
                  setActionPlan({ ...actionPlan, action: e.target.value });
                }}
                value={actionPlan.action}
                readOnly={!enableEdit}
              >
                {actions.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </TableCell>
          {enableEdit ? (
            <TableCell>
              {actionPlan.action === "Direct Consulting" ? (
                <Button disabled variant="contained" sx={{ width: "150px" }}>
                  Direct Consulting
                </Button>
              ) : (
                <></>
              )}
              {actionPlan.action === "Resource Referral" ? (
                <Button
                  variant="contained"
                  onClick={handleResourceSelection}
                  sx={{ width: "150px" }}
                >
                  Resource Referral
                </Button>
              ) : (
                <></>
              )}
              {actionPlan.action === "B2B Referral" ? (
                <Button
                  variant="contained"
                  onClick={handleB2BSelection}
                  sx={{ width: "150px" }}
                >
                  B2B<br></br> Referral
                </Button>
              ) : (
                <></>
              )}
            </TableCell>
          ) : (
            <TableCell></TableCell>
          )}
          <TableCell>
            {enableEdit ? (
              <Stack direction={"row"}></Stack>
            ) : (
              <StyledButtonMain
                variant="contained"
                sx={{
                  float: "right",
                  fontSize: "20px",
                }}
                onClick={() => onEdit && onEdit(actionPlan)}
              >
                Edit
              </StyledButtonMain>
            )}
          </TableCell>
        </TableRow>
        <TableRow
          sx={
            {
              // border: "5px solid #941566",
              // borderTop: "hidden",
              // borderLeft: "hidden",
              // borderRight: "hidden",
            }
          }
        >
          <TableCell sx={{ paddingTop: 0 }}>
            <Stack direction={"row"} sx={{ width: "900px" }}>
              <FormControl sx={{ margin: "auto", width: "250px" }}>
                <InputLabel id="demo-multiple-chip-label">
                  Business Objective
                </InputLabel>
                <Select
                  label="Business Objective"
                  onChange={(e: any) => {
                    setActionPlan({
                      ...actionPlan,
                      businessObjective: e.target.value,
                    });
                  }}
                  value={actionPlan.businessObjective}
                  readOnly={!enableEdit}
                >
                  {assistances.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <StyledTextarea
                sx={{
                  marginTop: "8px",
                  marginLeft: "30px",
                  width: { xs: "300px", md: "670px" },
                }}
                minRows={1.5}
                placeholder="Business Action Plan Note"
                value={actionPlan.note}
                onChange={(e) => {
                  setActionPlan({ ...actionPlan, note: e.target.value });
                }}
                readOnly={!enableEdit}
              />
            </Stack>
          </TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableBody>
    </TableContainer>
  );
};

export default BusinessActionPlanCard;
